import React from 'react'
import {
    CardEvents,
    CollectionEvent,
    Product,
    PublicationCardItemWithoutVideo,
    useFeature,
} from '@news-mono/web-common'
import { getLatestLiveBlog } from './content-selector-helper'
import {
    LatestLiveBlogMilestones,
    GetLinkWithChildrenComponent,
} from './components/LatestLiveBlogMilestones'
import { TNLiveBlogMilestones } from './components/TNLiveBlogMilestones'
import { useTheme } from '@emotion/react'

export interface CardContentWithLiveBlogsProps {
    result?: PublicationCardItemWithoutVideo
    isVrTest?: boolean
    DefaultComponent: JSX.Element
    getLinkComponentWithChildren?: GetLinkWithChildrenComponent
    onEvent: (event: CardEvents | CollectionEvent) => void
    hasBackground?: boolean
}
export const CardContentWithLiveBlogs = ({
    isVrTest,
    result,
    getLinkComponentWithChildren,
    DefaultComponent,
    hasBackground = false,
}: CardContentWithLiveBlogsProps): JSX.Element | null => {
    const theme = useTheme()
    const isTheNightly = theme.kind === Product.TheNightly
    const isTheWest = theme.kind === Product.TheWest

    const isLiveBlogTeaserMilestonesEnabled = useFeature(
        'live-blog-milestones-teaser',
    )

    if (!result) {
        return null
    }

    // check the publication kind to see if it's an event and if the toggle is enabled
    const isLiveBlog =
        result.publicationKind === 'event' && isLiveBlogTeaserMilestonesEnabled
    const eventLiveBlogTextLength = 250

    // Not a live blog, so we should just show the default component.
    if (!isLiveBlog) {
        return DefaultComponent
    }

    // Else, now we need to fetch the posts.
    const postsToRetrieve = isTheWest ? 3 : 5
    const latestLiveBlogPosts = getLatestLiveBlog(
        result.entries,
        eventLiveBlogTextLength,
        postsToRetrieve,
    )

    // No post was found, so we probably should just show the teaser as a fallback.
    if (!latestLiveBlogPosts || latestLiveBlogPosts.length === 0) {
        return DefaultComponent
    }

    if (isTheNightly) {
        return (
            <TNLiveBlogMilestones
                posts={latestLiveBlogPosts}
                getLinkComponentWithChildren={getLinkComponentWithChildren}
            />
        )
    }

    return (
        <LatestLiveBlogMilestones
            isVrTest={isVrTest}
            posts={latestLiveBlogPosts}
            getLinkComponentWithChildren={getLinkComponentWithChildren}
            hasBackground={hasBackground}
        />
    )
}
